import React, { useEffect, useRef, useState } from "react";
import { Button, Label } from "./elements";
import { Txt } from "./generalComponets";
export const AppInput = ({
  mt,
  ml,
  mr,
  mb,
  fl,
  disabled,
  fieldSize,
  time,
  password,
  file,
  subText,
  style,
  title,
  date,
  number,
  maxLength,
  placeholder,
  inputProps,
  hide_error,
  show_err_height,
  err,
  fill,
  onChange,
  value,
  focus,
  onEnterPress,
}) => {
  const [visible, setVisible] = useState(false);
  const inref = useRef();
  const t_focus = () => {
    inref.current.focus();
  };
  useEffect(() => {
    if (focus) {
      focus(() => {
        t_focus();
      });
    }
  }, []);
  return (
    <div
      className="form-group mg-b-0"
      style={{
        flex: fl ? 1 : null,
        marginTop: mt ? mt : 0,
        marginLeft: ml ? ml : 0,
        marginRight: mr ? mr : 0,
        marginBottom: mb ? mb : 0,
        display: "flex",
        flexDirection: "column",
        position: "relative",
        ...style,
      }}
    >
      <Label style={{ textAlign: "left" }} className="mc-label-field-title">
        {title}
      </Label>

      <input
        className={`mc-label-field-input ${fieldSize || "w-md h-sm"}`}
        disabled={disabled}
        type={date ? "date" : number ? "number" : time ? "time" : !visible && password ? "password" : file ? "file" : "text"}
        value={value}
        maxLength={maxLength}
        placeholder={placeholder}
        onChange={onChange}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (onEnterPress) {
              onEnterPress();
            }
          }
        }}
        style={{
          border: err ? "red 1px solid" : "",
          width: fill ? "100%" : "auto",
        }}
        {...inputProps}
      />
      {password && (
        <Button
          type="button"
          className="material-icons"
          style={{ position: "absolute", right: 12, top: 27 }}
          onClick={() => setVisible(!visible)}
        >
          {visible ? "visibility_off" : "visibility"}
        </Button>
      )}

      {hide_error ? null : show_err_height && !err ? (
        <div style={{ height: 18 }} />
      ) : (
        <Txt style={{ width: "100%" }} s={12} a="l" c={err ? "r" : ""}>
          {err ? (typeof err.message === "string" ? err.message : "") : subText}
        </Txt>
      )}
    </div>
  );
};
